// @owners { team: patients }
import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';

/**
 * Valid background color keys that can be configured via partner configs.
 * These match the keys in COLORS.BACKGROUND_COLORS from design-library-tokens.
 */
const VALID_BACKGROUND_COLOR_KEYS = [
  'PRIMARY_LIGHTEST',
  'SECONDARY_LIGHTEST',
  'PINK_LIGHTEST',
  'TERTIARY_LIGHTEST',
  'SUCCESS_LIGHTEST',
  'WARNING_LIGHTEST',
  'GREY_LIGHTER',
] as const;

type BackgroundColorKey = (typeof VALID_BACKGROUND_COLOR_KEYS)[number];

const isValidBackgroundColorKey = (key: string): key is BackgroundColorKey =>
  VALID_BACKGROUND_COLOR_KEYS.includes(key as BackgroundColorKey);

/**
 * Converts a background color config string to a design system BACKGROUND_COLORS value.
 *
 * Backend sends color values matching design token keys (e.g., 'PRIMARY_LIGHTEST', 'PINK_LIGHTEST').
 * This function performs a direct lookup in COLORS.BACKGROUND_COLORS.
 */
export const getBackgroundColorFromConfig = (
  backgroundColorConfig: string | null | undefined,
): BACKGROUND_COLORS_VALUES | undefined => {
  if (!backgroundColorConfig || !isValidBackgroundColorKey(backgroundColorConfig)) {
    return undefined;
  }
  return COLORS.BACKGROUND_COLORS[backgroundColorConfig];
};
